import React from "react";
import useApiRequestMonitor from "../../hooks/useApiRequestMonitor";
import "./ApiStatusBanner.css";

const ApiStatusBanner = () => {
  const { slowRequests, failedIssues } = useApiRequestMonitor((snapshot) => ({
    slowRequests: snapshot.activeRequests.filter((request) => request.isSlow),
    failedIssues: snapshot.recentIssues.filter((issue) => issue.kind === "failed"),
  }));

  if (!slowRequests.length && !failedIssues.length) {
    return null;
  }

  const visibleItems = [...slowRequests, ...failedIssues].slice(0, 3);
  const title = slowRequests.length
    ? "Some data is taking longer than usual to load."
    : "A few requests failed to load data.";

  return (
    <div className="api-status-banner" role="status" aria-live="polite">
      <div className="api-status-banner__icon">
        <i className={`bi ${slowRequests.length ? "bi-hourglass-split" : "bi-exclamation-triangle"}`} />
      </div>
      <div className="api-status-banner__content">
        <strong>{title}</strong>
        <span>
          {visibleItems.map((item) => item.label).join(", ")}
          {slowRequests.length + failedIssues.length > visibleItems.length ? " and more" : ""}
        </span>
      </div>
    </div>
  );
};

export default ApiStatusBanner;
